import {
  FunctionComponent,
  useEffect,
  useCallback,
  useState,
  useRef,
} from 'react'
import { FaPlus } from 'react-icons/fa'
import { useHistory } from 'react-router'
import ContainerPage from 'shared/components/ContainerPageNew'
import { colors } from 'shared/styles/colors'
import Buscar from 'shared/components/Buscar'
import { Grid } from '@material-ui/core'
import { IValueBuscar } from 'shared/components/Buscar/BuscarComponent.types'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import SnackBar from 'shared/components/SnackBar'
import Button from 'shared/components/Button'
import Table from 'shared/components/Table'
import { IListUsuario } from 'modules/user/domain/usecases/ListUsuario'
import IDadosUsuarioResponse from 'modules/user/domain/entities/DadosUsuario'
import { useAuth } from 'modules/auth/hooks/auth'
import { isUserEditable } from 'shared/utils/isUserEditable'

type TProps = {
  listUsuario: IListUsuario
}

const UsuariosVinculados: FunctionComponent<TProps> = ({ listUsuario }) => {
  const history = useHistory()
  const { perfil } = useAuth()
  const [nome, setNome] = useState('')
  const inputCnpjRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [openErrorMessage, setOpenErrorMessage] = useState(false)
  const [tableData, setTableData] = useState<IDadosUsuarioResponse[]>([])

  const handleEditFn = useCallback(
    (usuarioResponse: IDadosUsuarioResponse) => {
      history.push('/usuarios-vinculados/edit', {
        params: usuarioResponse,
        isEditable: isUserEditable(perfil, usuarioResponse.perfil),
      })
    },
    [history, perfil],
  )

  const fetchCnpj = useCallback(
    async (nome: string) => {
      setLoading(true)
      try {
        setLoading(false)
        const response = await listUsuario.execute(nome)
        const tableDataResponse = response.map(item => {
          return {
            ...item,
            handleEdit: () => handleEditFn(item),
          }
        })
        setTableData(tableDataResponse)
        setLoading(false)
      } catch (e: unknown) {
        if (e instanceof Error) {
          setErrorMessage(e.message)
        } else {
          setErrorMessage('Erro ao tentar buscar usuários')
        }
        setOpenErrorMessage(true)
        setLoading(false)
      }
    },
    [listUsuario, handleEditFn],
  )

  useEffect(() => {
    async function init() {
      fetchCnpj(nome)
    }
    init()
  }, [nome, fetchCnpj])

  const handleSubmit = async (values: IValueBuscar) => {
    setNome(values.valueInput)
  }

  return (
    <>
      <ContainerPage
        breadCrumb="Home / Gerenciar Conta / Usuários"
        title="Usuários"
        showFooterScaffold={false}
      >
        <Grid container>
          <Grid item xs={8}>
            <Buscar
              handleSubmit={handleSubmit}
              inputBuscarRef={inputCnpjRef}
              placeholder="Digite para buscar"
              label="Buscar usuário"
              loading={loading}
            />
          </Grid>
          <Grid item xs={2} style={{ padding: '25px 0px 0px' }}>
            <Button
              color={colors.white}
              style={{
                marginRight: 10,
                color: colors.gray,
                border: '1px solid',
              }}
              onClick={() => {
                history.goBack()
              }}
            >
              Voltar
            </Button>
          </Grid>
          <Grid item xs={2} style={{ padding: '25px 0px 0px' }}>
            <Button
              color={colors.green}
              onClick={() => {
                history.push('/vincular-usuario')
              }}
            >
              <FaPlus color={colors.white} /> Novo usuário
            </Button>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <Table data={tableData} type="usuario_vinc" />
          </Grid>
        </Grid>
      </ContainerPage>
      <SnackBar
        open={openErrorMessage}
        setOpen={setOpenErrorMessage}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
    </>
  )
}

export default UsuariosVinculados
